import { ActionMenusProps } from '@/features/ap_payees/components/DocInstructionMenu/types';
import { useTranslation } from '@/i18n';
import {
  ActionMenu,
  ButtonV2Props,
  IconTrailing,
} from '@moneyforward/ap-frontend-components';
import { FC, useMemo } from 'react';
import { useItems } from './useItems';

export const ActionMenus: FC<ActionMenusProps> = ({
  onSendEmail,
  disabledSendmail,
  handleOpenInstructionPdfDialog,
  disabledExportPdf,
  dropDownProps,
  isDisabled,
}) => {
  const { t } = useTranslation();
  const items = useItems({
    onSendEmail,
    disabledSendmail,
    handleOpenInstructionPdfDialog,
    disabledExportPdf,
  });

  const buttonProps: ButtonV2Props = useMemo(
    () => ({
      children: t('instruction_menu_document_instruction'),
      color: 'primary',
      isSecondary: true,
      isTertiary: false,
      rightIcon: <IconTrailing size={16} />,
      isDisabled,
    }),
    [t, isDisabled]
  );

  return (
    <ActionMenu
      type='button'
      items={items}
      buttonProps={buttonProps}
      dropDownProps={dropDownProps}
    />
  );
};
